import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface PermissionDeniedEvent {
  permission?: string;
  reason?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PermissionErrorService {
  private permissionDenied$ = new Subject<PermissionDeniedEvent>();

  onPermissionDenied(): Observable<PermissionDeniedEvent> {
    return this.permissionDenied$.asObservable();
  }

  emitPermissionDenied(event: PermissionDeniedEvent): void {
    this.permissionDenied$.next(event);
  }
}
